<template>
  <el-scrollbar style="height: 100%">
    <div class="firstPage">
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="itemBox">
            <div class="itemTop">
              <span class="itemTopText">{{ item.title }}</span>
            </div>
            <div class="itemCon">
              <div class="itemNum">{{ item.num }}</div>
              <div class="itemBottom">
                <span class="itemBottomTitle">{{ item.text }}</span>
                <span class="itemBottomText">{{ item.textNum }}单</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 订单数量 -->
      <div class="order">
        <div
          v-for="item in orderList"
          :key="item.StatusName"
          class="order-item"
          @click="handleOrderInfo(item)"
        >
          <div class="order-item-tit">{{ item.StatusName }}</div>
          <div class="order-item-num">{{ item.OrderNum }}</div>
        </div>
      </div>
      <!-- 快捷访问 -->
      <div class="itemFunView">
        <div
          class="itemFun"
          v-for="(info, ind) in shortcutList"
          :key="ind"
          @click="setItem(info)"
        >
          <i
            :class="'itemFunImg ' + info.icon"
            :style="'color: ' + info.iconColor + ';'"
          ></i>
          <span class="itemFunText">{{ info.text }}</span>
        </div>
      </div>
      <div class="census">
        <div class="censusTitle">
          <img class="censusTitleImg" src="@/assets/img/census.png" />
          <span class="censusTitleText">统计</span>
        </div>
        <div class="censusCon">
          <div class="censusConItem" id="goodsECharts"></div>
          <div class="censusConItem" id="priceECharts"></div>
          <div class="censusConItem" id="searchECharts"></div>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
// 导入图标功能
import * as echarts from "echarts";

export default {
  name: "firstPage",
  data() {
    return {
      entId: "",
      list: [
        {
          title: "会员数量",
          num: "0",
          text: "今日订单数",
          textNum: "0",
        },
        {
          title: "订单总数",
          num: "0",
          text: "昨日订单数",
          textNum: "0",
        },
        {
          title: "总金额",
          num: "0",
          text: "近七天订单数",
          textNum: "0",
        },
        {
          title: "商品总数",
          num: "0",
          text: "本月订单数",
          textNum: "0",
          list: [],
        },
      ],
      shortcutList: [
        {
          text: "商品管理",
          icon: "el-icon-goods",
          iconColor: "#73c4ff",
          name: "商品列表",
          parentName: "商品管理",
        },

        {
          text: "会员管理",
          icon: "el-icon-user",
          iconColor: "#91E6E1",
          name: "客户列表",
          parentName: "客户管理",
        },
        {
          text: "订单管理",
          icon: "el-icon-s-order",
          iconColor: "#ff9c6e",
          name: "订单列表",
          parentName: "订单管理",
        },
        {
          text: "优惠券管理",
          icon: "el-icon-s-ticket",
          iconColor: "#b37feb",
          name: "优惠券列表",
          parentName: "促销管理",
        },
        {
          text: "促销管理",
          icon: "el-icon-postcard",
          iconColor: "#FFDD83",
          name: "促销活动",
          parentName: "促销管理",
        },
        // {
        //   text: "专区管理",
        //   icon: "el-icon-notebook-1",
        //   iconColor: "#9de071",
        //   name: "专区列表",
        //   parentName: "专区管理",
        // },
        // {
        //   text: "签到管理",
        //   icon: "el-icon-s-check",
        //   iconColor: "#FF85C0",
        //   name: "签到规则",
        //   parentName: "积分商城",
        // },
        // {
        //   text: "商城配置",
        //   icon: "el-icon-set-up",
        //   iconColor: "#FFD399",
        //   name: "商城配置",
        //   parentName: "商城管理",
        // },
      ],
      orderList: [], //订单列表
    };
  },
  mounted() {
    this.entId = window.localStorage.getItem("entId");
  },
  activated() {
    // 之前都是在mounted中请求数据，但是有弊端，就是数据加载一次后就不更新了，所以放在activated中
    this.getNumData();
    this.getOrder();
    this.getGoods();
    this.getPrice();
    this.getSearch();
    // this.getMode()
    this.getOrderList();
  },
  methods: {
    handleOrderInfo(item) {
      if (item.StatusName == "待退款") {
        console.log("121212");
        //打开订单列表界面
        this.setItem({
          name: "退款申请", //对应菜单跳转得子级菜单名称
          parentName: "订单管理", //对应菜单跳转得父级菜单名称
        });
        console.log("2222");
        window.sessionStorage.setItem("keyword", item.StatusName);
      } else if (item.StatusName == "客户待审核") {
        //打开订单列表界面
        this.setItem({
          name: "注册审核",
          parentName: "客户管理",
        });
      } else {
        //打开订单列表界面
        this.setItem({
          name: "订单列表",
          parentName: "订单管理",
        });
        // 然后使用本地存储向订单界面发送事件
        window.sessionStorage.setItem("keyword", item.StatusName);
      }
    },

    // 设置功能区域跳转
    setItem(item) {
      // 展开了功能菜单列表
      let el = document.querySelector("#menu" + item.parentName);
      if (!el.parentNode.parentNode.attributes["aria-expanded"]) {
        el.click();
      }
      document.querySelector("#menuTwo" + item.name).click();
    },
    // 获取数量数据
    getNumData() {
      let data = {
        type: "GetInfoTotals",
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          let data = res.data && res.data[0];
          if (res.flag == 0 && data) {
            this.list[0].num = data.usernum;
            this.list[1].num = data.ordernum;
            this.list[2].num = parseFloat(data.ordertotalamount);
            this.list[3].num = data.articlenum;
          } else {
            this.list[0].num = 0;
            this.list[1].num = 0;
            this.list[2].num = 0;
            this.list[3].num = 0;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取订单数量
    getOrder() {
      let data = {
        type: "GetAllOrderCount",
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          let data = res.data && res.data[0];
          if (res.flag == 0 && data) {
            this.list[0].textNum = data.today;
            this.list[1].textNum = data.yesterday;
            this.list[2].textNum = data.sevenday;
            this.list[3].textNum = data.monthday;
          } else {
            this.list[0].textNum = 0;
            this.list[1].textNum = 0;
            this.list[2].textNum = 0;
            this.list[3].textNum = 0;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取下单商品数量
    getGoods() {
      let data = {
        type: "Pc_ProductSaveOrder",
        startDate: "",
        endDate: "",
        strWhere: "",
        datetype: "0",
        PageIndex: 1,
        PageSize: 10,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data.map((item) => ({
              name: item.sub_title,
              // value: item.Num,
              value: item.quantity,
            }));
            let goodsECharts = echarts.init(
              document.getElementById("goodsECharts")
            );
            goodsECharts.setOption({
              title: {
                text: "商品下单分析",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 16,
                },
              },
              tooltip: {
                trigger: "item",
              },
              series: [
                {
                  name: "下单商品",
                  type: "pie",
                  data: data,
                  radius: ["20%", "66%"],
                  itemStyle: {
                    borderRadius: 10,
                    borderColor: "#fff",
                    borderWidth: 2,
                  },
                },
              ],
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取搜索商品数据
    getSearch() {
      let data = {
        type: "GoodsSearch",
        startDate: "",
        endDate: "",
        strWhere: "",
        datetype: "0",
        PageIndex: 1,
        PageSize: 10,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data.map((item) => ({
              name: item.SearchValue,
              value: item.Num,
            }));
            let searchECharts = echarts.init(
              document.getElementById("searchECharts")
            );
            searchECharts.setOption({
              title: {
                text: "商品点击统计",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 16,
                },
              },
              tooltip: {
                trigger: "item",
              },
              series: [
                {
                  name: "搜索热词",
                  type: "pie",
                  data: data,
                  radius: ["20%", "66%"],
                  itemStyle: {
                    borderRadius: 10,
                    borderColor: "#fff",
                    borderWidth: 2,
                  },
                },
              ],
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取订单金额
    getPrice() {
      let data = {
        type: "GetDayOrderAmount",
        dates: 30,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            // let data = this.changePriceRes(res.data, 30);
            let data = res.data;

            let priceECharts = echarts.init(
              document.getElementById("priceECharts")
            );
            priceECharts.setOption({
              color: ["#A7A7FF", "#FFFFFF"],
              title: {
                text: "订单金额统计",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 16,
                },
              },
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c}",
              },
              xAxis: {
                // data: data.map((item) => item.name),
                data: data.map((item) => item.rq),
              },
              yAxis: {
                axisLabel: {
                  margin: 2,
                  formatter: function (value) {
                    return value / 1000 + "k";
                  },
                },
              },
              series: [
                {
                  name: "每日金额",
                  type: "line",
                  // data: data.map((item) => item.value),
                  data: data.map((item) => item.amount),
                },
              ],
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 金额日期处理
    changePriceRes(list, dates) {
      let obj = {};
      let data = [];
      // 当前日期减去传入的天数
      let date = new Date().getTime() - 1000 * 60 * 60 * 24 * dates;
      for (let i = 1; i <= dates; i++) {
        obj[this.$formatDate(date + i * 1000 * 60 * 60 * 24)] = "0";
      }
      for (let i = 0; i < list.length; i++) {
        obj[list[i].rq] = list[i].amount;
      }
      for (let key in obj) {
        data.push({
          name: key,
          value: obj[key],
        });
      }
      return data;
    },
    // 获取首页跳转模块
    getMode() {
      let data = {
        type: "GetAdminManaShortCut",
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            console.log(res, "23232");
            this.list.forEach((item, index) => {
              let list = [];
              list.push(
                JSON.parse(res.data[index * 2].link_name.replaceAll("'", '"'))
              );
              list.push(
                JSON.parse(
                  res.data[index * 2 + 1].link_name.replaceAll("'", '"')
                )
              );
              item.list = list;
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取表格_这个没有分页 */
    getOrderList() {
      let data = {
        entId: this.entId,
      };

      this.$request({
        url: "Management/DataAnalysisAdmin/GetOrderTaskStatistic",
        method: "post",
        data,
      })
        .then((res) => {
          if (res.success) {
            this.orderList = res.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.firstPage {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #ebf1f3;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.item {
  width: 24%;
}

.itemBox {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.itemTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #f2f4f9;
}

.itemTopText {
  display: inline-block;
  font-size: 16px;
  color: #333;
  line-height: 20px;
  font-weight: bold;
}

.itemCon {
  box-sizing: border-box;
  width: 100%;
  padding: 0 20px;
}

.itemNum {
  width: 100%;
  font-size: 42px;
  color: #3d3e40;
  line-height: 70px;
  border-bottom: 1px solid #f2f4f9;
}

.itemBottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
}

.itemBottomTitle {
  display: inline-block;
  font-size: 16px;
  color: #646464;
  line-height: 20px;
}

.itemBottomText {
  display: inline-block;
  font-size: 16px;
  color: #646464;
  line-height: 20px;
}

.itemFunView {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 20px auto 0;
}

.itemFun {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  width: 48%;
  height: 80px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  cursor: pointer;
  margin-left: 10px;
}

.itemFun:first-of-type {
  margin-left: 0;
}

.itemFunImg {
  width: 40px;
  height: 40px;
  font-size: 40px;
}

.itemFunText {
  display: block;
  width: 100%;
  height: 30px;
  font-size: 16px;
  color: #242424;
  line-height: 30px;
  text-align: center;
}

.census {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.censusTitle {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #f0f0f7;
}

.censusTitleImg {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.censusTitleText {
  display: inline-block;
  font-size: 18px;
  color: #4d4f5c;
  line-height: 30px;
}

.censusCon {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 400px;
  padding: 20px 0;
}

.censusConItem {
  box-sizing: border-box;
  width: 32%;
  height: 100%;
  /* padding: 0 20px; */
}

/**订单信息 */
.order {
  width: 100%;
  margin-top: 20px;
  display: flex;
}

.order-item {
  margin-left: 10px;
  width: 110px;
  height: 80px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  overflow: hidden;
  flex-wrap: wrap;
  cursor: pointer;
}

.order-item:first-of-type {
  margin-left: 0;
}

.order-item-tit {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-item-num {
  margin-top: 10px;
  text-align: center;
  font-size: 30px;
  line-height: 1;
}
</style>